import { borderRadius, Button, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const CustomWatchlistButton = styled(Button)<{
  $isActive?: boolean;
}>`
  padding: 0;
  ${borderRadius.rFull};

  color: ${props =>
    props.$isActive ? 'var(--text-success)' : 'var(--text-default)'};
  border-color: ${props =>
    props.$isActive ? 'var(--border-success)' : 'var(--border-default)'};
  background-color: ${props =>
    props.$isActive ? 'var(--surface-success)' : 'var(--surface-default)'};
  svg {
    fill: ${props =>
      props.$isActive ? 'var(--icon-success)' : 'var(--icon-default)'};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const TickerWrapper = styled.div``;

export const Ticker = styled.span`
  display: flex;
  flex-direction: row;
`;

export const LeftImageContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const TitleContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  ${typographyV2.bodyMd};
`;

export const Tag = styled.p`
  color: var(--text-soft);
  text-transform: uppercase;
  align-items: center;
  ${typographyV2.bodyXs};
`;

export const WatchlistWrapper = styled.div`
  margin-top: 3px;
  align-self: flex-start;
`;
